export default __webpack_public_path__ + "static/media/Icon material-add-circle.311bcfb9.svg";